.content {
  margin-left: 70px;
  min-height: 100vh;
  transition: margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  width: calc(100% - 70px);
}

/* When sidebar is expanded, content stays in place (sidebar overlays) */
.content.collapsed {
  margin-left: 70px;
  width: calc(100% - 70px);
}

/* Responsive design */
@media (max-width: 768px) {
  .content {
    margin-left: 0;
    width: 100%;
  }

  .content.collapsed {
    margin-left: 0;
    width: 100%;
  }
}

@media print {
  .content {
    margin-left: 0 !important;
    width: 100% !important;
  }

  .content.collapsed {
    margin-left: 0 !important;
    width: 100% !important;
  }
}
